import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';
import { collection, query, where, getDocs, orderBy, limit, startAfter, getCountFromServer } from 'firebase/firestore';

import './journal.css';

function ResearchPaper() {
  // State management
  const [research, setResearch] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Journal Articles from Firestore -
  const fetchResearches = async (page) => {
    try {
      const pageSize = 6; // Number of items per page
      const researchRef = collection(db, 'mainresources');
      let q = query(
        researchRef,
        where('resourceType', '==', 'Research'),
        orderBy('created_at'),
        limit(pageSize)
      );

      if (page > 1 && lastVisible) {
        q = query(
          researchRef,
          where('resourceType', '==', 'Research'),
          orderBy('created_at'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);
      const researches = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setResearch(researches);
      setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);

      // Calculate total pages using count query
      const countSnapshot = await getCountFromServer(query(researchRef, where('resourceType', '==', 'Research')));
      const totalPages = Math.ceil(countSnapshot.data().count / pageSize);
      setTotalPages(totalPages);

    } catch (error) {
      console.error("Error fetching journal articles:", error);
    }
  };

  // Handle pagination click
  const paginate = (page) => {
    setCurrentPage(page);
    fetchResearches(page);
  };

  useEffect(() => {
    fetchResearches(currentPage);
  }, [currentPage]);

 return (
  <div className="journal-page-container">

    {/* HERO SECTION */}
    <section className="hero">

      <div className="hero-image">
        <img
          src="/imgbook.png"
          alt="Research Publications"
        />
      </div>

      <div className="hero-content">

        <h1>Eye Care Digital Library</h1>

        <p>
          Explore ophthalmic research studies,
          evidence-based publications, clinical
          investigations, and scientific findings
          in optometry and vision science.
        </p>

      </div>

    </section>

    {/* PAGE HEADER */}
    <div className="journal-heading-section">

      <h2>Research Publications</h2>

      <p>
        Browse professional ophthalmology and
        vision science research materials
        including clinical studies, healthcare
        innovations, disease management
        investigations, and academic scientific
        publications.
      </p>

    </div>

    {/* RESEARCH GRID */}
    <div className="articles-container">

      {research.length > 0 ? (

        research.map((item) => (

          <div
            key={item.id}
            className="article-item"
          >

            {/* COVER IMAGE */}
            {item.coverImageURL && (
              <img
                src={item.coverImageURL}
                alt={item.title}
                className="book-cover-image"
              />
            )}

            {/* CONTENT */}
            <div className="article-content">

              {/* TITLE */}
              <h4>{item.title}</h4>

              {/* META DETAILS */}
              <div className="book-meta-data">

                {item.author && (
                  <p>
                    <strong>Author:</strong>{" "}
                    {item.author}
                  </p>
                )}

                {item.publication_year && (
                  <p>
                    <strong>Year:</strong>{" "}
                    {item.publication_year}
                  </p>
                )}

                {item.isbn && (
                  <p>
                    <strong>ISBN:</strong>{" "}
                    {item.isbn}
                  </p>
                )}

              </div>

              {/* DESCRIPTION */}
              {item.description && (
                <p className="book-description">
                  {item.description}
                </p>
              )}

              {/* BUTTON */}
              {item.pdfFileURL && (
                <a
                  href={item.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read Research
                </a>
              )}

            </div>

          </div>

        ))

      ) : (

        <div className="no-books-found">

          <h3>No Research Publications Available</h3>

          <p>
            No ophthalmology research materials
            or scientific publications have been
            uploaded yet.
          </p>

        </div>

      )}

    </div>

    {/* PAGINATION */}
    {totalPages > 1 && (

      <div className="pagination-container">

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage - 1)
          }
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {Array.from(
          { length: totalPages },
          (_, index) => (

            <button
              key={index + 1}
              className={`pagination-button ${
                currentPage === index + 1
                  ? 'active'
                  : ''
              }`}
              onClick={() =>
                paginate(index + 1)
              }
            >
              {index + 1}
            </button>

          )
        )}

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage + 1)
          }
          disabled={
            currentPage === totalPages
          }
        >
          Next
        </button>

      </div>

    )}

  </div>
);
}

export default ResearchPaper